import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import compose from "recompose/compose";

import "./main.scss";
import { Typography } from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

const theme = createTheme({
  palette: {
    primary: {
      main: "#002BB8",
    },
    secondary: {
      main: "#7200B8",
    },
    info: {
      main: "#3177EA",
    },
  },
});

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  exampleWrapper: {
    position: "relative",
    marginTop: theme.spacing(3),
    height: 380,
  },
  radioGroup: {
    margin: theme.spacing(1, 0),
  },
  speedDial: {
    position: "absolute",
    "&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft": {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    "&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight": {
      top: theme.spacing(2),
      left: theme.spacing(2),
    },
  },
  rootDial: {
    transform: "translateZ(0px)",
    flexGrow: 1,
  },
});

class VisitLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visits: "",
    };
  }

  componentDidMount() {
    document.title = "Visit Log | Appleby Wellness";
    axios
      .get(
        process.env.REACT_APP_DOMAIN +
          `/visits/patient/${this.props.match.params.id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      )
      .then(({ data }) => {
        this.setState({
          visits: data.filter(function (visit) {
            return !visit.blocked && !visit.rescheduled && !visit.noshow;
          }),
        });
      });
  }

  handleBackClick = () => {
    this.props.history.push("/patient/" + this.props.match.params.id);
  };

  render() {
    return (
      <>
        {!this.state.visits ? (
          <div>
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                width: 500,
                height: 200,
                marginTop: -100,
                marginLeft: -250,
                textAlign: "center",
              }}
            >
              <Typography component="h1" style={{ fontSize: 25 }}>
                Welcome to Appleby Wellness
              </Typography>
              <Typography component="p" style={{ fontWeight: "lighter" }}>
                Loading in your information.
              </Typography>
              <CircularProgress style={{ margin: "3rem" }} />
            </div>
          </div>
        ) : (
          <>
            <div>
              <ThemeProvider theme={theme}>
                <div style={{ margin: 30 }}>
                  <Typography
                    style={{ textAlign: "left" }}
                    variant="h4"
                    id="title"
                  >
                    Patient Log
                  </Typography>
                  <Button
                    onClick={this.handleBackClick}
                    style={{ float: "right", marginTop: -40 }}
                    variant="outlined"
                    color="primary"
                    disableElevation
                  >
                    Back
                  </Button>

                  <TableContainer>
                    <Table
                      aria-label="simple table"
                      style={{ width: "100%", marginTop: 20, marginBottom: 20 }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell>Date</TableCell>
                          <TableCell>Service</TableCell>
                          <TableCell>Sign In Time</TableCell>
                          <TableCell>Signature</TableCell>
                          <TableCell>Sign Out Time</TableCell>
                          <TableCell>Signature</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.visits.map((visit) => (
                          <TableRow key={visit._id}>
                            <TableCell component="th" scope="row">
                              {visit.date.start.slice(0, 10)}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {visit.service[0].type}
                            </TableCell>
                            {visit.signIn.yn ? (
                              <TableCell>
                                {new Date(visit.signIn.time).toLocaleTimeString(
                                  "en-US",
                                  {
                                    hour12: false,
                                  }
                                )}
                              </TableCell>
                            ) : (
                              <TableCell>NA</TableCell>
                            )}
                            {visit.signIn.yn ? (
                              <TableCell>
                                <img
                                  src={visit.signIn.signature}
                                  alt="Sign in signature"
                                  style={{ width: 260, height: 120 }}
                                />
                              </TableCell>
                            ) : (
                              <TableCell>NA</TableCell>
                            )}
                            {visit.signOut.yn ? (
                              <TableCell>
                                {new Date(
                                  visit.signOut.time
                                ).toLocaleTimeString("en-US", {
                                  hour12: false,
                                })}
                              </TableCell>
                            ) : (
                              <TableCell>NA</TableCell>
                            )}
                            {visit.signOut.yn ? (
                              <TableCell>
                                {" "}
                                <img
                                  src={visit.signOut.signature}
                                  alt="Sign out signature"
                                  style={{ width: 260, height: 120 }}
                                />
                              </TableCell>
                            ) : (
                              <TableCell>NA</TableCell>
                            )}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </ThemeProvider>
            </div>
          </>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    visits: state.visits,
    patients: state.patients,
  };
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, null)
)(withRouter(VisitLog));
